import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useIlluminationModeEnabled = (iotDevice) => {
    const isGlobalLedIntensity = iotDeviceGlobalConfigService.isGlobalLedIntensity(iotDevice);
    const isGlobalExtendedLedIntensity = iotDeviceGlobalConfigService.isGlobalExtendedLedIntensity(iotDevice);
    const isLedFeatureAvailable =
        iotDeviceFeatureConfigService.isDeviceLedModeEnabled() ||
        iotDeviceFeatureConfigService.isHolderLedModeEnabled();
    const isExtendedLedFeatureAvailable =
        iotDeviceFeatureConfigService.isExtendedDeviceLedModeEnabled() ||
        iotDeviceFeatureConfigService.isExtendedHolderLedModeEnabled();
    const isIlluminationModeEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalLedIntensity,
        isLedFeatureAvailable,
        false
    );
    const isExtendedIlluminationModeEnabled = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        isGlobalExtendedLedIntensity,
        isExtendedLedFeatureAvailable,
        false
    );

    return {isIlluminationModeEnabled, isExtendedIlluminationModeEnabled};
};

export default useIlluminationModeEnabled;
